<span class="campaign-countdown-cell campaign-countdown-cell-left">{{ hours }}</span>
<span class="campaign-countdown-delimiter">&#58;</span>
<span class="campaign-countdown-cell">{{ minutes }}</span>
<span class="campaign-countdown-delimiter">&#58;</span>
<span class="campaign-countdown-cell campaign-countdown-cell-right">{{ seconds }}</span>
